import { EConfiguratorQuestionType, IConfiguratorSection } from '../models/configurator.model';
import {
  BUDGET_RANGE_OPTIONS,
  configuratorIcon,
  DEADLINE_FIXED,
  DEADLINE_REASON_OPTIONS,
  DEADLINE_TYPE_OPTIONS,
  PRIORITY_OPTIONS,
  YES_NO_UNKNOWN_OPTIONS
} from './configurator-options.data';
import { hasAnswer, isAnswer } from './configurator-predicates';

const T = 'ProjectConfiguratorV2.Questions';
const S = 'ProjectConfiguratorV2.Sections';

const hasFixedDeadline = isAnswer('deadlineType', DEADLINE_FIXED);

/** Step 6 "Budget & Zeitrahmen". Nothing is required. */
export const BUDGET_STEP_SECTIONS: IConfiguratorSection[] = [
  {
    id: 'budget',
    icon: configuratorIcon('euro'),
    title: `${S}.budget`,
    questions: [
      {
        id: 'budgetRange',
        type: EConfiguratorQuestionType.CHIPS,
        summaryLabel: `${T}.budgetRange.summary`,
        label: `${T}.budgetRange.label`,
        help: `${T}.budgetRange.help`,
        options: BUDGET_RANGE_OPTIONS,
        allowCustom: true,
        maxCustom: 1,
        customWide: true,
        customLabel: `${T}.budgetRange.customLabel`,
        customPlaceholder: `${T}.budgetRange.customPlaceholder`
      },
      {
        id: 'priorities',
        type: EConfiguratorQuestionType.TRIANGLE,
        summaryLabel: `${T}.priorities.summary`,
        label: `${T}.priorities.label`,
        options: PRIORITY_OPTIONS
      },
      {
        id: 'fundingInterest',
        type: EConfiguratorQuestionType.CHIPS,
        summaryLabel: `${T}.fundingInterest.summary`,
        label: `${T}.fundingInterest.label`,
        options: YES_NO_UNKNOWN_OPTIONS
      }
    ]
  },
  {
    id: 'timeframe',
    icon: configuratorIcon('calendar'),
    title: `${S}.timeframe`,
    questions: [
      {
        id: 'deadlineType',
        type: EConfiguratorQuestionType.CHIPS,
        summaryLabel: `${T}.deadlineType.summary`,
        label: `${T}.deadlineType.label`,
        options: DEADLINE_TYPE_OPTIONS
      },
      {
        id: 'termEnd',
        type: EConfiguratorQuestionType.DATE,
        summaryLabel: `${T}.termEnd.summary`,
        label: `${T}.termEnd.label`,
        half: true,
        show: hasFixedDeadline
      },
      {
        id: 'deadlineReason',
        type: EConfiguratorQuestionType.CHIPS,
        summaryLabel: `${T}.deadlineReason.summary`,
        label: `${T}.deadlineReason.label`,
        options: DEADLINE_REASON_OPTIONS,
        allowCustom: true,
        show: hasFixedDeadline
      },
      {
        id: 'termStart',
        type: EConfiguratorQuestionType.DATE,
        summaryLabel: `${T}.termStart.summary`,
        label: `${T}.termStart.label`,
        help: `${T}.termStart.help`,
        half: true
      },
      {
        id: 'termStartUncertain',
        type: EConfiguratorQuestionType.CHECKBOX,
        summaryLabel: `${T}.termStartUncertain.summary`,
        text: `${T}.termStartUncertain.text`,
        summaryValue: (_, context) => context.translate(`${T}.termStartUncertain.summaryValue`),
        show: hasAnswer('termStart')
      }
    ]
  }
];
